/**
 * V2 小白态的一行「问 → 选 → 为什么」。
 *
 * 三件事绑在一起不是排版偏好:
 *  · **问句**代替参数名(「这块的数字要一字不差吗?」而不是「渲染档」);
 *  · **选项**说结果(「要 · 好看且不差」而不是「B · AI皮+精确数字」);
 *  · **为什么**只显示**当前选中那一档**的那句 —— 三句全铺出来是说明书,
 *    用户要的是"我现在这样会怎样"。
 * 文案一律来自 `resultLanguage.ts`,本组件不自带任何字串(单源纪律)。
 */
import { cn } from "@/shared/lib/utils";
import type { EasyChoice } from "../model/resultLanguage";

interface Props<V extends string> {
  question: string;
  choices: ReadonlyArray<EasyChoice<V>>;
  value: V;
  onPick: (v: V) => void;
  /** 额外说明(接在「为什么」后面,如二维码块为什么不给选)。 */
  note?: string;
}

export function EasyChoiceRow<V extends string>({
  question,
  choices,
  value,
  onPick,
  note,
}: Props<V>) {
  const current = choices.find((c) => c.value === value);
  return (
    <div>
      <p className="mb-1.5 text-xs font-medium">{question}</p>
      <div className="inline-flex flex-wrap gap-1 rounded-full border border-border/60 bg-card/40 p-0.5">
        {choices.map((c) => (
          <button
            key={c.value}
            type="button"
            aria-pressed={value === c.value}
            onClick={() => onPick(c.value)}
            className={cn(
              "rounded-full px-3 py-1 text-xs font-medium transition-colors",
              value === c.value
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {c.easyLabel}
          </button>
        ))}
      </div>
      {(current || note) && (
        <p className="mt-1.5 text-2xs leading-relaxed text-muted-foreground">
          {current?.why}
          {note ? (current ? ` ${note}` : note) : ""}
        </p>
      )}
    </div>
  );
}
